import { Block } from 'slate';
import { getEventTransfer } from 'slate-react'

import {
  NODE_TYPE as NT,
  receivableTypes,
} from 'shared/constants/slate';

import { keycodeFromEvent, isUrl } from 'shared/helpers';

import { ensureNoOrphanReceiver } from '../rules';
import {
  getIfCollapsedInTargetBlockType,
  insertNodeAfterTarget,
  makeNodeProps,
} from '../utils';



export const HandleReceiver = (opts) => {

  const onKeyDown = (event, change, editor) => {
    const targetBlock = getIfCollapsedInTargetBlockType(change, receivableTypes);
    if (!targetBlock) return;

    const { code, kc } = keycodeFromEvent(event);

    const isReceiving = targetBlock.data.get('isReceiving', false);
    if (isReceiving) {
      if (
          (event.ctrlKey || event.metaKey)
          && code === kc.codes.v
      ) {
        // Do not touch cmd+v paste command.
        return;
      }

      const { right, left } = kc.codes;
      if ( code === right
        || code === left
        || event.key.length === 1
      ) {
        event.preventDefault();
        return change;
      }

      const { enter, backspace } = kc.codes;
      if ( code === enter
        || code === backspace
      ) {
        event.preventDefault();
        return change.setBlock(NT.default);
      }

      return;
    }

    // Still needs it, even if not editable
    const error = targetBlock.data.get('error', null);
    if (error) {
      const { enter, backspace } = kc.codes;
      if ( code === enter
        || code === backspace
      ) {
        event.preventDefault();
        return change.setBlock(NT.default);
      }

      return;
    }

    // src may be present after erroring, so check this last.
    const src = targetBlock.data.get('src');
    if (src) {
      if (code === kc.codes.enter) {
        // Don't return change here, let slate do its thing
        insertNodeAfterTarget(change, targetBlock, NT.paragraph);
      }

      return;
    }
  }

  const onPaste = (event, change, editor) => {
    const targetBlock = getIfCollapsedInTargetBlockType(change, receivableTypes);
    if (!targetBlock) return;

    const isReceiving = targetBlock.data.get('isReceiving', false);
    if (!isReceiving) return;

    const transfer = getEventTransfer(event);
    const { type, text } = transfer;

    // Only deal with text url, noop if not.
    if (type !== 'text' || !isUrl(text)) {
      return false;
    }

    event.preventDefault();

    // Should be closely mirroring onFileLoadInsertImageSrc() for image..
    // But trying to use it for some reason messes up caretShadow
    // position sometimes.. :\ oh well.
    const nodeProps = makeNodeProps({
      type: targetBlock.type,
      isVoid: true,
    }, {
      src: text,
      isReceiving: false,
      error: false,
    });

    // Insert block above current block.
    const { value } = change;
    const { startBlock, document: doc } = value;
    const index = doc.nodes.findIndex(n => n.key === startBlock.key);
    const block = Block.create(nodeProps)

    return change
      .setBlock(NT.default)
      .insertNodeByKey(doc.key, index, block)
  }

  // NOTE: Not really sure why and unhappy about this, but when
  // blur -> focus into doc, triggering normalizeDocument does
  // not seem to invoke validateNode rules.. ALSO, selction
  // isn't updated when first focus into doc, so wrap it in
  // setTimeout in 0 sec to make it work.. FML.
  const onFocus = (event, change, editor) => {
    const { match, validate, normalize } = ensureNoOrphanReceiver;

    setTimeout(() => {
      const { value } = editor;
      const { document: doc } = value;

      const receivers = doc.nodes.filter(node => match(node));
      if (!receivers.size) return null;

      const orphans = receivers.filter(node => !!validate(node));
      if (!orphans.size) return null;

      const c = value.change()
      orphans.forEach(node => normalize(c, node));

      return editor.onChange(c);
    }, 0);  // o_O
  }

  return {
    onKeyDown,
    onPaste,
    onFocus,
  };
}



// WEBPACK FOOTER //
// ./src/components/slate/plugins/HandleReceiver.js